import { getApiBaseUrl, getStoredToken, safeApiRequest } from './apiClient';
import { getCsrfToken } from './authService';

const ENDPOINT = '/api/admin/db-backups';

export const fetchDbBackupToolsStatus = async () => {
  return safeApiRequest(`${ENDPOINT}/tools-status`, { method: 'GET', skipCsrf: true });
};

export const fetchDbCollections = async () => {
  return safeApiRequest(`${ENDPOINT}/collections`, { method: 'GET', skipCsrf: true });
};

export const fetchDbBackups = async () => {
  return safeApiRequest(ENDPOINT, { method: 'GET', skipCsrf: true });
};

export const createDbBackup = async ({ collections, label }) => {
  return safeApiRequest(ENDPOINT, {
    method: 'POST',
    body: { collections, label: label || undefined },
  });
};

export const deleteDbBackup = async (id) => {
  return safeApiRequest(`${ENDPOINT}/${id}`, { method: 'DELETE' });
};

export const restoreDbBackup = async (id, confirmText) => {
  return safeApiRequest(`${ENDPOINT}/${id}/restore`, {
    method: 'POST',
    body: { confirmText },
  });
};

export const downloadDbBackup = async (id, filename) => {
  const token = getStoredToken();
  const response = await fetch(`${getApiBaseUrl()}${ENDPOINT}/${id}/download`, {
    method: 'GET',
    headers: { Authorization: `Bearer ${token}` },
    credentials: 'include',
  });

  if (!response.ok) {
    const json = await response.json().catch(() => ({}));
    const err = new Error(json?.mesaj || 'Yedek indirilemedi');
    err.status = response.status;
    throw err;
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'backup.zip';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const previewDbBackupUpload = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const headers = {};
  try {
    const csrfToken = await getCsrfToken();
    if (csrfToken) headers['X-CSRF-Token'] = csrfToken;
  } catch {
    // continue
  }

  const response = await fetch(`${getApiBaseUrl()}${ENDPOINT}/restore-upload/preview`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${getStoredToken()}`,
      ...headers,
    },
    body: formData,
    credentials: 'include',
  });

  const json = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(json?.mesaj || 'Yedek önizlenemedi');
    err.status = response.status;
    err.data = json;
    throw err;
  }
  return json;
};

export const confirmDbBackupUpload = async ({ uploadToken, confirmText }) => {
  return safeApiRequest(`${ENDPOINT}/restore-upload/confirm`, {
    method: 'POST',
    body: { uploadToken, confirmText },
  });
};
